module.exports = __webpack_public_path__ + "static/media/m_eyeshape_upturned_hazel.e04b7475.png";